import gql from 'graphql-tag'

export const REQUEST_REGISTER_OTP = gql`
  mutation ($input: RequestRegisterOtpInput!) {
    requestRegisterOtp(input: $input) {
      errors
    }
  }
`

export default {
  REQUEST_REGISTER_OTP
}
